import { ApiModel } from "./api-model";

export class Language extends ApiModel {
  id: number;
  isDefault: boolean;
  value: string;
  isoCode: string;
  timeZone: string;
  features: string[];

  get nameAndTimeZone() {
    return this.value + " " + this.timeZone;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/language.ts